define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'model/RecoveryStrategy',
	'service/EventListenerRegistry',
	'service/EidClientManager',
	'amdi18n-loader?!model/recoverystrategy/nls/ManualRecoveryStrategy_strings'
], function (
	Logger,
	Util,
	UiUtil,
	RecoveryStrategy,
	EventListenerRegistry,
	EidClientManager,
	Strings
) {
	'use strict';

	/**
	 * ManualRecoveryStrategy class
	 */
	function ManualRecoveryStrategy(eidClientManager) {
		var _eidClientId = 'http://ws.skidentity.de/oi/go/client/TR03124Client',
			_eidClientManager,
			_isStarted = false,
			_authenticationOption,
			_eventListener;

		if (eidClientManager instanceof EidClientManager) {
			_eidClientManager = eidClientManager;
		} else {
			throw new Error('no valid eidClientManager found');
		}

		RecoveryStrategy.call(this, 'http://ws.skidentity.de/oi/rs/manual');


		// private methods

		function log(method, message, data) {
			Logger.log('ManualRecoveryStrategy', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}


		// public methods

		this.name = function () {
			return "eID-Client";
		};

		this.icon = function () {
			return UiUtil.getImage('MANUAL_RECOVERY_BUTTON');
		};
		
		this.description = function () {
			return Strings.description;
		};

		this.isUsable = function (authenticationOption) {
			var _name = 'isUsable',
				client = _eidClientManager.eidClientById(_eidClientId);

			if (client === null) {
				log(_name, Strings.app_not_available);
				return false;
			}

			if (!client.supportsPlatform()) {
				log(_name, Strings.platform_not_supported);
				return false;
			}

			if (!client.supportsAuthenticationOption(authenticationOption)) {
				log(_name, Strings.authentication_option_not_supported);
				return false;
			}

			return true;
		};

		this.start = function (authenticationOption, callbacks, errorCallbacks) {
			var _name = 'start',
				self = this,
				client = _eidClientManager.eidClientById(_eidClientId);

			if (_isStarted) {
				return;
			}

			_authenticationOption = authenticationOption;

			_eventListener = function (eidClients) {
				_eidClientManager.stopDetection(_authenticationOption);

				client.disableDetection();

				for (var i = 0; i < eidClients.length; i++) {
					if (eidClients[i].id() === _eidClientId) {
						callLog(_name, Strings.succeeded, self, 'RECOVERY_STRATEGY_SUCCEEDED', callbacks);
						return;
					}
				}

				callLog(_name, Strings.failed, self, 'RECOVERY_STRATEGY_FAILED', errorCallbacks);
			};

			_isStarted = true;

			callLog(_name, Strings.started, this, 'RECOVERY_STRATEGY_STARTED');

			client.enableDetection();

			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', _eventListener);

			_eidClientManager.startDetection(_authenticationOption);
		};

		this.stop = function () {
			var client = _eidClientManager.eidClientById(_eidClientId);

			if (!_isStarted) {
				return;
			}

			_isStarted = false;

			client.disableDetection();

			EventListenerRegistry.removeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', _eventListener);

			_eidClientManager.stopDetection(_authenticationOption);

			callLog('stop', Strings.stopped, this, 'RECOVERY_STRATEGY_STOPPED');
		};
	}

	ManualRecoveryStrategy.prototype = Object.create(RecoveryStrategy.prototype);

	return ManualRecoveryStrategy;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/recoverystrategy/ManualRecoveryStrategy.js
// module id = 295
// module chunks = 3